export const CLASS_OPTIONS = [
  'Early morning session ',
  'Late morning session ',
  'Afternoon session ',
  'Evening session ',
  'Late Evening session ',
  'Any time'
];

export const SIM_PRIORITY_OPTIONS = [
  '1st Request',
  '2nd Request',
  '3rd Request'
];

export const ART_CLASS_OPTIONS = ['AM', 'PM', 'Any time'];

// SIM class options as key-value pairs
// Key: No-space identifier, Value: Display name with spaces
export const SIM_CLASS_OPTIONS_MAP: Record<string, string> = {
  EarlyMorningSession: 'Early morning session',
  LateMorningSession: 'Late morning session',
  AfternoonSession: 'Afternoon session',
  EveningSession: 'Evening session',
  LateEveningSession: 'Late Evening session',
  AnyTime: 'Any time'
};

// Array of display values for dropdown (with spaces and time details)
export const SIM_CLASS_OPTIONS = Object.values(SIM_CLASS_OPTIONS_MAP);

// Array of values for backend/simplified display
export const SIM_CLASS_VALUES = Object.values(SIM_CLASS_OPTIONS_MAP);

// Reverse mapping from display names to no-space keys
export const SIM_CLASS_REVERSE_MAP: Record<string, string> = Object.entries(
  SIM_CLASS_OPTIONS_MAP
).reduce(
  (acc, [key, value]) => {
    acc[value] = key;
    return acc;
  },
  {} as Record<string, string>
);

// map each option string to its descriptive info
export const CLASS_INFO: Record<string, string> = {
  EarlyMorningSession:
    'Early Morning Session approximately starts at 0600-1000',
  LateMorningSession: 'Late Morning Session approximately starts at 1000-1400',
  AfternoonSession: 'Afternoon Session approximately starts at 1400-1800',
  EveningSession: 'Evening Session approximately starts at 1800-2200',
  LateEveningSession: 'Late Evening Session approximately starts at 2200',
  AnyTime: 'Any time — choose any available slot'
};

export const ART_CLASS_OPTIONS_MAP: Record<string, string> = {
  AM: 'AM',
  PM: 'PM',
  AnyTime: 'Any time'
};

// Mapping for table display - shows full session names
export const ART_CLASS_TABLE_DISPLAY: Record<string, string> = {
  AM: 'Morning session',
  PM: 'Evening session',
  AnyTime: 'Any time'
};

export const ART_CLASS_INFO: Record<string, string> = {
  AM: 'AM class: 8:00am – 3:30pm.',
  PM: 'PM class: 3:30pm – 11:00pm. ',
  AnyTime: 'Any time — choose any available slot'
};

export const ART_CLASS_VALUES = Object.values(ART_CLASS_OPTIONS_MAP);

export const ART_CLASS_REVERSE_MAP: Record<string, string> = Object.entries(
  ART_CLASS_OPTIONS_MAP
).reduce(
  (acc, [key, value]) => {
    acc[value] = key;
    return acc;
  },
  {} as Record<string, string>
);
